import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getMemeLanguageDistribution } from '@opm/services';
import { useEffect, useState } from 'react';

export function useMemeLangDistribution({ filter }: { filter: any }) {
  const [data, setData] = useState<any>({ views_dist: [], videos_dist: [] });
  const { wrapperCancelRequest, loading } = useCancelRequestHook({defaultLoading: true});

  function request() {
    if (!filter?.meme_title) return;
    wrapperCancelRequest(getMemeLanguageDistribution, filter)
      .then(data => {
        setData({
          views_dist: Array.isArray(data?.views_dist) ? data.views_dist : [],
          videos_dist: Array.isArray(data?.videos_dist) ? data.videos_dist : [],
        });
      })
      .catch(() => {});
  }

  useEffect(() => {
    if (filter) {
      request();
    }
  }, [filter]);

  return {
    data,
    loading,
  };
}
